import { addUnit, toDate } from '../helpers/date';
import { CamEventConfig } from '../types';
import { CamRecord } from './record';

export class CamEventRecord extends CamRecord<CamEventConfig> {
  constructor(data?: CamEventConfig) {
    super(data);
    const start = toDate(this.data.startDate);
    if (start && !toDate(this.data.endDate) && this.data.duration) {
      this.data.endDate = addUnit(start, this.getDurationUnit(), this.data.duration);
    }
  }

  public getName(): string {
    return this.data.name ?? '';
  }

  public getStartDate(): Date {
    return toDate(this.data.startDate) ?? new Date();
  }

  public getEndDate(): Date {
    return toDate(this.data.endDate) ?? this.getStartDate();
  }

  public getDuration(): number {
    return this.data.duration ?? 1;
  }

  public getDurationUnit(): string {
    return this.data.durationUnit ?? 'hour';
  }

  public getResourceId(): string | number | null {
    return this.data.resourceId ?? null;
  }

  public isAllDay(): boolean {
    return !!this.data.allDay;
  }

  public setDates(startDate: Date, endDate: Date): void {
    this.setData({ endDate, startDate });
  }

  public setResourceId(resourceId: string | number | null): void {
    this.setData('resourceId', resourceId);
  }
}

export class CamResourceRecord extends CamRecord {}

export class CamTimeRangeRecord extends CamRecord {}
